import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLazyGetItemsQuery } from "../api/businessApi";
import { Calendar, User, ArrowRight } from "lucide-react";

const ItemsPage = () => {
  const [getItems, { data: itemsData, isLoading, error }] = useLazyGetItemsQuery();
  const [items, setItems] = useState([]);

  useEffect(() => {
    // Fetch all items (no limit)
    getItems();
  }, [getItems]);

  useEffect(() => {
    if (itemsData?.items) {
      setItems(itemsData.items);
    } else if (itemsData) {
      // Handle case where data might be directly the items array
      setItems(Array.isArray(itemsData) ? itemsData : []);
    }
  }, [itemsData]);

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center">
          <div className="animate-pulse space-y-4">
            <div className="h-2 bg-gray-200 rounded w-32 mx-auto"></div>
            <div className="h-2 bg-gray-200 rounded w-24 mx-auto"></div>
          </div>
          <p className="text-gray-600 mt-4 font-light">Loading stories...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center max-w-md">
          <h2 className="text-3xl font-light mb-4 text-gray-800">Unable to Load Stories</h2>
          <p className="text-gray-600 mb-6 font-light">
            {error?.data?.message || error?.message || "We couldn't fetch the stories at this time."}
          </p>
          <button
            onClick={() => getItems()}
            className="bg-black text-white px-6 py-3 rounded-none hover:bg-gray-800 transition-colors duration-300 text-sm tracking-wide"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#f5f5f5] py-10 min-h-screen">

      <div className="max-w-7xl mx-auto bg-white border border-gray-400  md:mt-8">

        {/* ================= HEADER ================= */}
        <div className="text-center border-b-2 border-gray-400 py-4">
          <h1 className="text-2xl font-semibold tracking-wide">
            AI-Tijarat al-Raabehah Chicago Monthly Newsletter
          </h1>
        </div>


        {/* ================= RIGHT ARTICLES ================= */}
        <div className="grid grid-cols-1 md:grid-cols-3 divide-x-2 divide-gray-300">
          {items.map((item, index) => (

            <div key={item.id} className="p-4 space-y-3">

              {/* IMAGE */}
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-52 object-cover"
              />

              {/* TITLE */}
              <h2 className={`text-lg font-bold leading-snug ${index % 2 === 0 ? "text-green-600" : "text-orange-500"
                }`}>
                {item.title}
              </h2>

              {/* SUBTITLE */}
              {item.subtitle && (
                <p className="text-sm font-semibold">
                  {item.subtitle}
                </p>
              )}

              {/* DESCRIPTION */}
              {item.description && (
                <div
                  className="text-sm leading-relaxed text-gray-800"
                  dangerouslySetInnerHTML={{
                    __html: item.description
                      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                      .replace(/\*(.*?)\*/g, '<em>$1</em>')
                      .replace(/## (.*)/g, '<h3>$1</h3>')
                      .replace(/^- (.*)/gm, '• $1')
                      .replace(/\n/g, '<br>')
                  }}
                />
              )}

            </div>

          ))}
        </div>
      </div>
    </div>
  );

};

export default ItemsPage;
